import script from "./WizardSummaryField.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardSummaryField.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__